export default new Map([['key', 'value']]);
